import { useCallback } from 'react';

import { useBrowserLanguage } from '@/hooks/useBrowserLanguage';

import { useBrowserAudioSetting } from './useBrowserAudioSetting';
import { useBrowserHistory } from './useBrowserHistory';
import { useBrowserTranslationDisplay } from './useBrowserTranslationDisplay';
import { useBrowserUILanguage } from './useBrowserUILanguage';
import { useGlossaryEntries } from './useGlossaryEntries';
import { useLoginUserInfo } from './useLoginUserInfo';

/**
 * ローカルストレージ削除用 hooks
 */
export const useClearLocalStorage = () => {
  const { resetState: resetLanguage } = useBrowserLanguage();
  const { resetHistoryListState } = useBrowserHistory();
  const { resetState: resetTranslationDisplay } =
    useBrowserTranslationDisplay();
  const { resetState: resetAudioSetting } = useBrowserAudioSetting();
  const { resetState: resetUILanguage } = useBrowserUILanguage();
  const { resetState: resetLoginUserInfo } = useLoginUserInfo();
  const { resetState: resetGlossaryEntries } = useGlossaryEntries();

  /**
   * ローカルストレージ削除を実行する
   */
  const doCleanLocalStorage = useCallback(() => {
    resetLanguage();
    resetHistoryListState();
    resetTranslationDisplay();
    resetAudioSetting();
    resetUILanguage();
    resetLoginUserInfo();
    resetGlossaryEntries();
  }, [
    resetLanguage,
    resetHistoryListState,
    resetTranslationDisplay,
    resetAudioSetting,
    resetUILanguage,
    resetLoginUserInfo,
    resetGlossaryEntries,
  ]);

  return {
    doCleanLocalStorage,
  };
};
